<template>
  <main class="platform-login">
    <section class="platform-login__card">
      <button type="button" class="platform-login__back" @click="$router.push('/')">
        <i class="mdi mdi-arrow-left"></i>
        На главную
      </button>

      <div class="platform-login__mark">S</div>
      <span class="platform-login__eyebrow">Sauda · владельцу платформы</span>
      <h1>Супер-админка</h1>
      <p>Войдите под e-mail владельца, чтобы увидеть все подключённые компании.</p>

      <form @submit.prevent="login">
        <label>
          <span>E-mail</span>
          <input
            v-model.trim="email"
            type="email"
            autocomplete="email"
            placeholder="name@example.com"
            required
          >
        </label>

        <label>
          <span>Пароль</span>
          <div class="platform-login__password">
            <input
              v-model="password"
              :type="showPassword ? 'text' : 'password'"
              autocomplete="current-password"
              placeholder="Введите пароль"
              required
            >
            <button type="button" :title="showPassword ? 'Скрыть пароль' : 'Показать пароль'" @click="showPassword = !showPassword">
              <i :class="['mdi', showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline']"></i>
            </button>
          </div>
        </label>

        <p v-if="error" class="platform-login__error"><i class="mdi mdi-alert-circle-outline"></i>{{ error }}</p>

        <button class="platform-login__submit" type="submit" :disabled="loading">
          <i v-if="loading" class="mdi mdi-loading mdi-spin"></i>
          {{ loading ? 'Проверяем доступ...' : 'Войти в супер-админку' }}
        </button>
      </form>
    </section>
  </main>
</template>

<script>
import http from '@/api/http'

export default {
  name: 'PlatformAdminLogin',
  data() {
    return {
      email: '',
      password: '',
      showPassword: false,
      loading: false,
      error: '',
    }
  },
  methods: {
    async login() {
      this.error = ''
      this.loading = true
      try {
        const { data } = await http.post('platform-admin/login', {
          email: this.email,
          password: this.password,
        })

        localStorage.setItem('access_token', data.token)
        localStorage.setItem('user_name', data.user_name || '')
        localStorage.setItem('is_platform_admin', '1')
        this.$router.replace('/super-admin')
      } catch (error) {
        this.error = (error.response && error.response.data && error.response.data.message)
          || 'Не удалось выполнить вход'
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped lang="scss">
.platform-login {
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 24px;
  background:
    radial-gradient(circle at 12% 10%, rgba(40, 137, 215, .18), transparent 38%),
    linear-gradient(135deg, #10243a, #163a52);
}
.platform-login__card {
  position: relative;
  width: min(100%, 440px);
  padding: 42px 36px 36px;
  border-radius: 24px;
  background: #fff;
  box-shadow: 0 28px 70px rgba(0, 0, 0, .26);
  color: #152033;
}
.platform-login__back {
  position: absolute; top: 18px; left: 18px; border: 0; background: transparent; color: #60738a;
  font-size: 13px; cursor: pointer;
}
.platform-login__back .mdi { margin-right: 4px; }
.platform-login__mark {
  width: 48px; height: 48px; display: grid; place-items: center; margin-bottom: 18px; border-radius: 14px;
  background: #0b4f8a; color: #fff; font-size: 22px; font-weight: 850;
}
.platform-login__eyebrow { color: #0b4f8a; font-size: 11px; font-weight: 800; letter-spacing: .05em; text-transform: uppercase; }
h1 { margin: 7px 0; font-size: 27px; letter-spacing: -.03em; }
.platform-login__card > p { margin: 0 0 25px; color: #6b7a90; line-height: 1.5; font-size: 14px; }
form { display: flex; flex-direction: column; gap: 17px; }
label > span { display: block; margin-bottom: 7px; color: #3d4f63; font-size: 13px; font-weight: 700; }
input { width: 100%; padding: 13px 14px; border: 1.5px solid #d9e2ec; border-radius: 12px; color: #152033; font-size: 15px; outline: none; }
input:focus { border-color: #0b4f8a; box-shadow: 0 0 0 4px rgba(11,79,138,.1); }
.platform-login__password { position: relative; }
.platform-login__password input { padding-right: 44px; }
.platform-login__password button { position: absolute; right: 8px; top: 7px; width: 34px; height: 34px; border: 0; border-radius: 9px; background: transparent; color: #6b7a90; cursor: pointer; }
.platform-login__password button:hover { background: #f1f5f9; color: #0b4f8a; }
.platform-login__error { display: flex; gap: 7px; align-items: center; margin: -4px 0 0; color: #b42318; font-size: 13px; }
.platform-login__submit { display: inline-flex; align-items: center; justify-content: center; gap: 8px; padding: 14px; border: 0; border-radius: 12px; background: #0b4f8a; color: #fff; font-size: 15px; font-weight: 750; cursor: pointer; }
.platform-login__submit:hover:not(:disabled) { background: #093f6d; }
.platform-login__submit:disabled { opacity: .65; cursor: wait; }
@media (max-width: 480px) { .platform-login { padding: 14px; } .platform-login__card { padding: 42px 22px 24px; } }
</style>
